<template>
    <div class="h-full cursor-pointer">
        <vx-card class="overflow-hidden relative h-full h_card" v-on="$listeners">
            <div slot="no-body" class="h-full">
                <div class="p-4">
                 
                    <div class="center">
                        <span class="text-lg font-semibold block text-center" style="color:rgba(var(--vs-primary), 1)">
                            {{fullName(history.student)}}
                        </span>
                       
                        <div class="flex justify-center mt-2">
                            <div class="w-5/12 flex justify-center items-center" >
                                {{ShotName(history.old_advisor)}}
                            </div>
                            <div class="w-2/12 flex justify-center">
                                <vs-button radius color="warning" type="filled" icon-pack="feather" icon="icon-arrow-right"></vs-button>
                            </div>
                            <div class="w-5/12 flex justify-center items-center">
                                {{ShotName(history.new_advisor)}}
                            </div>
                        </div>

                        <vs-divider/>
                        
                        <vs-col class="w-full">
                            <small class='font-medium'>{{$t('cause')}}: </small>
                            <small>{{history.cause}}</small>
                        </vs-col>

                        <vs-col class="w-full" v-if="history.comment">
                            <small class='font-medium'>{{$t('answer')}}: </small>
                            <small>{{history.comment}}</small>
                        </vs-col>

                        <vs-col class="w-full">
                            <small class='font-medium'>{{$t('status')}}: {{history.status.name}}</small>
                            <vs-progress :height="8" :percent="getOrderStatusColor(history.status.alias,'progress')" :color="getOrderStatusColor(history.status.alias)"></vs-progress>
                        </vs-col>

                    </div>
                </div>
              
              
            </div>
        </vx-card>
    </div>
</template>

<script>

import userSetting from '@/localNodeModules/setting/user.js'
export default {
    name: "ItemGridView",
    mixins:[userSetting],
    props: {
        history: {
            type: Object,
            required: true,
        }
    },

    methods: {
     
        getOrderStatusColor (status,type='') {
            var response = ''
            switch(status) {
                case 'await':
                   response = ['warning',30];break;
                case 'processing':
                   response = ['primary',60];break;
                case 'accepted':    
                   response = ['success',100];break;
                case 'declined':    
                   response = ['danger',100];break;
            }

            if(type == 'progress'){
                return response[1]
            }else{
             return response[0]
            }
        },
    },
}
</script>

<style lang="scss">

    .h_card{
        .vx-card__collapsible-content{
            height: 100%;
            padding-bottom: 39px;
        }
    }
</style>
